import { render, staticRenderFns } from "./NominaHistoric.vue?vue&type=template&id=f90a7fac&scoped=true&"
import script from "./NominaHistoric.vue?vue&type=script&lang=js&"
export * from "./NominaHistoric.vue?vue&type=script&lang=js&"
import style0 from "./NominaHistoric.vue?vue&type=style&index=0&id=f90a7fac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90a7fac",
  null
  
)

export default component.exports